import produce from 'immer';

import { IMigrationScript } from '../../../utils/prepareWidgetblockMigrationScripts';
import { DataTableConfigBlockState } from '../types';

const addUnitLabelsToHeadings: IMigrationScript<DataTableConfigBlockState> = (state) => {
    const headings = state.settings.headings.map((heading) => ({
        ...heading,
        databilityUnitLabels: heading.databilityUnitLabels ? heading.databilityUnitLabels : heading.databilityUnits,
    }));

    return produce(state, (draft) => {
        draft.settings.headings = headings;
    });
};

export default addUnitLabelsToHeadings;
